export default  {
    path: 'channelrebate',
    component: () => import('@/pages/channelrebate/channelrebate'),
    meta: {title:'渠道返佣'},
  }   